import React, { useEffect, useState } from "react";

import "react-tooltip/dist/react-tooltip.css";

import { motion } from "framer-motion";

import { AppWrapper, MotionWrapper } from "../../wrapper";

//import ReactTooltip from "react-tooltip";

import { Tooltip as ReactTooltip } from "react-tooltip";

import { urlFor, client } from "../../client";

import "./Skills.scss";

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const experiencesQuery = "*[_type == 'experiences']";

    const skillsQuery = "*[_type == 'skills']";

    client
      .fetch(experiencesQuery)
      .then((data) => {
        setExperiences(data);
      })
      .catch((err) => console.log(err));

    client
      .fetch(skillsQuery)
      .then((data) => {
        setSkills(data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <h2 className="head-text">
        Skills <span>&</span> Education
      </h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill._id}
            >
              <div className="app__flex" style={{ background: skill.bgColor }}>
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {experience.works.map((work, index) => (
                  <div key={index}>
                    <motion.a
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-tooltip-id={work._key}
                      //data-tooltip-content={work.desc}
                      data-tooltip-place="top"
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.a>

                    <ReactTooltip
                      id={work._key}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </div>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrapper(
  MotionWrapper(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
